export default {
  googletagmanager: "https://www.googletagmanager.com",
  mysph: "https://static.idp.sph.com.sg",
  doubleclick: "https://securepubads.g.doubleclick.net",
  taboola: "https://cdn.taboola.com",
  adtag: "https://adtag.sphdigital.com",
};
